import { SearchInput } from "../../ui-kit/SearchInput"
import { AutocompleteInput } from "../../ui-kit/AutocompleteInput"
import { GRID_FORM_CONFIG_T } from "../../../common/FormGenerator"
import { GROWTHTOOLS_FILTRATION } from "../../../consts/formOptions"

export type FiltrationBlockName =
  | "search"
  | "authorGrowthTool"
  | "growthToolFocus"

export const searchConfig = [
  [
    {
      id: 1,
      controllerName: "search",
      RenderElement: SearchInput,
      renderProps: () => ({
        placeholder: "Поиск...",
        fullWidth: true,
        inputProps: { maxLength: 32 },
      }),
    },
  ],
]

export const authorConfig = [
  [
    {
      id: 2,
      controllerName: "source_type",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: GROWTHTOOLS_FILTRATION.SOURCE_TYPE,
        fullWidth: true,
      }),
    },
  ],
]

export const growthToolFocusConfig = [
  [
    {
      id: 3,
      controllerName: "content_type",
      RenderElement: AutocompleteInput,
      renderProps: () => ({
        placeholder: "",
        options: GROWTHTOOLS_FILTRATION.CONTENT_TYPE,
        fullWidth: true,
      }),
    },
  ],
]

const formConfigs: Record<FiltrationBlockName, GRID_FORM_CONFIG_T<any>> = {
  search: searchConfig,
  authorGrowthTool: authorConfig,
  growthToolFocus: growthToolFocusConfig,
}

export const getFormConfig = (blockName: FiltrationBlockName) => formConfigs[blockName]
